// API Configuration
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8080',
    apiURL: 'http://localhost:8080/api'
  },
  production: {
    // Use relative URLs in production since frontend and backend are served from the same domain
    baseURL: '',
    apiURL: '/api'
  }
};

// Determine current environment
const environment = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = API_CONFIG[environment].baseURL;
export const API_URL = API_CONFIG[environment].apiURL;

export default API_CONFIG[environment];
